import React from 'react';
import VersionHistorySection from '../VersionHistorySection';
import { useEpdVersionHistoryDataOrWhileLoadingThenNull } from '../utils/EpdVersionHistoryDataContext';
import { VersionHistorySummaryGridSkeleton } from '../VersionHistorySummaryGrid';
import VersionHistoryLcaInformationGrid from './VersionHistoryLcaInformationGrid';
import ContributionOfScrapInputsGridPdf from '../../grids/contribution-of-scrap-inputs/ContributionOfScrapInputsGridPdf';
import TransportationPerformanceGridPdf from '../../grids/specification/TransportationPerformanceGridPdf';
import DeclarationOfCO2GridPdf from '../../grids/declaration-of-co2/DeclarationOfCo2GridPdf';
import { YES_NO } from '../../constants';
import VersionHistoryDataQualityAssessmentGrid from './VersionHistoryDataQualityAssessmentGrid';
import ElectricityListPdf from '../../grids/electricity/ElectricityListPdf';
import BiogasDataListPdf from '../../grids/biogas/BiogasDataListPdf';
import VersionHistoryDataQualityAssessment from './VersionHistoryDataQualityAssessment';
import VersionHistoryDataQualityAssessmentGridComments from './VersionHistoryDataQualityAssessmentGridComments';

const VersionHistoryLcaInformationSection: React.FC<{}> = () => {
  const data = useEpdVersionHistoryDataOrWhileLoadingThenNull();

  return (
    <VersionHistorySection title="LCA information">
      {data ? (
        <>
          <VersionHistoryLcaInformationGrid />
          <ContributionOfScrapInputsGridPdf epdVersionId={data.epdVersionId} />
          <VersionHistoryDataQualityAssessment data={data} />
          <VersionHistoryDataQualityAssessmentGrid
            dataQualityAssessmentAndReferenceYears={data.dataQualityAssessmentAndReferenceYears}
          />
          <VersionHistoryDataQualityAssessmentGridComments data={data} />
          <ElectricityListPdf epdVersionId={data.epdVersionId} />
          <BiogasDataListPdf epdVersionId={data.epdVersionId} />
          {data.lcaSpecification?.shouldTransportationPerformanceBeFetched && (
            <TransportationPerformanceGridPdf epdVersionId={data.epdVersionId} />
          )}
          {data.lcaSpecification?.shouldDeclarationsBeFetched && (
            <DeclarationOfCO2GridPdf
              epdVersionId={data.epdVersionId}
              disabled={data.cO2UptakeAssociation.association !== YES_NO.YES}
            />
          )}
        </>
      ) : (
        <>
          <VersionHistorySummaryGridSkeleton skeletonRowsCount={11} />
          <VersionHistorySummaryGridSkeleton skeletonRowsCount={3} />
        </>
      )}
    </VersionHistorySection>
  );
};

export default VersionHistoryLcaInformationSection;
